var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 31,
    viewBox: "0 0 45 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2991 0.4021C39.7927 1.51779 38.5641 1.91769 35.9725 2.7871C34.8168 3.17476 34.4182 3.3423 34.3998 3.44804C34.3843 3.5371 34.7439 4.01456 35.3688 4.73463C36.8779 6.47369 36.8776 6.2669 35.3731 8.04991C33.0343 10.8215 23.6767 21.521 23.4992 21.6265C23.2911 21.7501 23.4497 21.916 19.6437 17.5958C14.6643 11.944 14.5116 11.8224 13.45 12.6646C12.6315 13.3139 0.529228 27.3343 0.181766 28.0357C-0.476751 29.365 0.763539 31.2233 2.14553 30.978C2.83026 30.8565 3.26346 30.3935 9.49014 23.1302C14.052 17.8088 14.1655 17.6796 14.2793 17.6796C14.331 17.6796 16.1484 19.657 18.3179 22.0737C22.4296 26.6539 22.7693 26.9897 23.357 27.0523C23.9685 27.1176 24.1906 26.9249 26.6079 24.2316C28.8179 21.7694 35.1056 14.5341 38.6251 10.4035C39.6018 9.25733 39.5198 9.26144 40.5445 10.3075C42.2314 12.0296 42.3262 12.0962 42.4763 11.663C42.5203 11.5363 42.8443 10.1495 43.1963 8.58138C43.5484 7.01329 44.0022 4.99449 44.2047 4.09515C44.7259 1.78143 45.045 0.153386 44.9948 0.0633264C44.9192 -0.0724345 44.5735 -0.00333807 43.2991 0.4021Z",
    fill: "#59B015"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrow);
export default __webpack_public_path__ + "static/media/grow.1745dd093529e45cf255121500984661.svg";
export { ForwardRef as ReactComponent };